import { ButtonV3 } from '@provi/provi-components'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { FaqDrawer } from '../../../components/faq-drawer'
import { MaxWidth } from '../../../components/max-width'
import { Template } from '../../../components/template'
import { getCrid, getSummaryInfoFromStorage, mapStorageToFormattedData } from '../helpers'
import { useNegotiationPayment } from '../hooks'
import { SummaryCard } from '../simulation/components/SummaryCard'
import { ProcessingWrapper, ProcessingContainer, ProcessingIconWrapper, ProcessingText } from '../simulation/styles'

import {
  PageContainer,
  PageGrid,
  PaymentCard,
  HeaderBadge,
  HeaderBadgeSuccess,
  HeaderIcon,
  HeaderText,
  ContentWrapper,
  SectionTitle,
  SectionSubtitle,
  PaidSuccessBanner,
  PaidSuccessIconWrapper,
  PaidSuccessBannerText,
  SuccessButtonWrapper,
  WarningBanner,
  WarningIconWrapper,
  WarningContent,
  WarningTitle,
  WarningText,
  PixSection,
  PixLabel,
  PixQRCode,
  PixCopyButton,
  EntryCard,
  EntryRow,
  EntryLabel,
  EntryValue,
  EntrySubLabel,
  EntrySubValue,
  AlternativePayment,
  AlternativeText,
  AlternativeActions,
  AlternativeLink
} from './styles'

export const InstallmentPayment = () => {
  const history = useHistory()
  const crid = getCrid()
  const {
    formattedData: apiFormattedData,
    isLoading: apiIsLoading,
    isPaid,
    handleCopyPix,
    handleCopyBarcode,
    isCopying
  } = useNegotiationPayment(crid)

  const summaryInfo = getSummaryInfoFromStorage()
  const storageFormattedData = summaryInfo ? mapStorageToFormattedData(summaryInfo) : null

  const entryValueFromStorage = localStorage.getItem('negotiation_entry_value')
  const entryDueDateFromStorage = localStorage.getItem('negotiation_entry_due_date')

  const installmentsCountFromStorage = localStorage.getItem('negotiation_installments_count')
  const installmentValueFromStorage = localStorage.getItem('negotiation_installment_value')

  const formattedData = apiFormattedData
    ? {
        ...apiFormattedData,
        codigoPix: apiFormattedData.codigoPix,
        qrCodePixImage: apiFormattedData.qrCodePixImage,
        urlFaturaBoleto: apiFormattedData.urlFaturaBoleto,
        codigoDeBarrasBoleto: apiFormattedData.codigoDeBarrasBoleto,
        ...(storageFormattedData && {
          saldoDevedorAtual: storageFormattedData.saldoDevedorAtual,
          saldoDevedorAnterior: storageFormattedData.saldoDevedorAnterior,
          calculation: storageFormattedData.calculation,
          totalPagoAPrazo: storageFormattedData.totalPagoAPrazo,
          dataVencimentoPrimeiraParcela: storageFormattedData.dataVencimentoPrimeiraParcela
        }),
        valorEntrada:
          entryValueFromStorage ||
          (apiFormattedData.valorEntrada && apiFormattedData.valorEntrada !== '-' && apiFormattedData.valorEntrada !== 'R$ 0,00'
            ? apiFormattedData.valorEntrada
            : storageFormattedData?.valorEntrada || '-'),
        dataVencimentoEntrada:
          entryDueDateFromStorage ||
          (apiFormattedData.dataVencimentoEntrada && apiFormattedData.dataVencimentoEntrada !== '-'
            ? apiFormattedData.dataVencimentoEntrada
            : storageFormattedData?.dataVencimentoEntrada || '-'),
        quantidadeParcelas: installmentsCountFromStorage
          ? parseInt(installmentsCountFromStorage, 10)
          : storageFormattedData?.quantidadeParcelas || apiFormattedData.quantidadeParcelas || null,
        valorParcela:
          installmentValueFromStorage ||
          storageFormattedData?.valorParcela ||
          (apiFormattedData.valorParcela === '-' || !apiFormattedData.valorParcela ? null : apiFormattedData.valorParcela)
      }
    : storageFormattedData

  const isLoading = apiIsLoading || !formattedData

  if (isLoading || !formattedData) {
    return (
      <Template>
        <FaqDrawer />
        <PageContainer>
          <MaxWidth>
            <ProcessingWrapper>
              <ProcessingContainer>
                <ProcessingIconWrapper>
                  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 60 60"
                        to="360 60 60"
                        dur="1.5s"
                        repeatCount="indefinite"
                      />
                      <rect x="30" y="15" width="60" height="11.25" rx="5.625" fill="#2563EB" />
                      <rect x="30" y="93.75" width="60" height="11.25" rx="5.625" fill="#2563EB" />
                      <path
                        d="M39.375 26.25H80.625L67.5 45L67.5 52.5L80.625 71.25H39.375L52.5 52.5L52.5 45L39.375 26.25Z"
                        stroke="#0F172A"
                        strokeWidth="3.75"
                        strokeLinejoin="round"
                      />
                      <path d="M50.625 54.375H69.375" stroke="#0F172A" strokeWidth="3.75" strokeCap="round" />
                    </g>
                  </svg>
                </ProcessingIconWrapper>
                <ProcessingText>Aguarde um momento...</ProcessingText>
              </ProcessingContainer>
            </ProcessingWrapper>
          </MaxWidth>
        </PageContainer>
      </Template>
    )
  }

  return (
    <Template>
      <FaqDrawer />
      <PageContainer>
        <MaxWidth>
          <PageGrid>
            <PaymentCard>
              {isPaid ? (
                <HeaderBadgeSuccess>
                  <HeaderIcon>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM10.8036 16.8L19.2876 8.31491L17.5908 6.61817L10.8036 13.4062L7.40878 10.0114L5.71204 11.7081L10.8036 16.8Z"
                        fill="white"
                      />
                    </svg>
                  </HeaderIcon>
                  <HeaderText>Pagamento Confirmado</HeaderText>
                </HeaderBadgeSuccess>
              ) : (
                <HeaderBadge>
                  <HeaderIcon>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM10.8036 16.8L19.2876 8.31491L17.5908 6.61817L10.8036 13.4062L7.40878 10.0114L5.71204 11.7081L10.8036 16.8Z"
                        fill="white"
                      />
                    </svg>
                  </HeaderIcon>
                  <HeaderText>Acordo Realizado</HeaderText>
                </HeaderBadge>
              )}
              {isPaid ? (
                <ContentWrapper>
                  <div>
                    <SectionTitle>Pagamento de entrada confirmado com sucesso!</SectionTitle>
                    <SectionSubtitle>
                      Sua renegociação foi concluída e as próximas parcelas deverão ser pagas até as respectivas datas de
                      vencimento.
                    </SectionSubtitle>
                  </div>

                  <PaidSuccessBanner>
                    <PaidSuccessIconWrapper>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18ZM9 9H11V15H9V9ZM9 5H11V7H9V5Z"
                          fill="white"
                        />
                      </svg>
                    </PaidSuccessIconWrapper>
                    <PaidSuccessBannerText>
                      O comprovante de pagamento foi enviado para o seu e-mail cadastrado.
                    </PaidSuccessBannerText>
                  </PaidSuccessBanner>

                  <SuccessButtonWrapper>
                    <ButtonV3 text="Voltar para minhas faturas" onClick={() => history.push('/dashboard/faturas')} />
                  </SuccessButtonWrapper>
                </ContentWrapper>
              ) : (
                <ContentWrapper>
                  <div>
                    <SectionTitle>Acordo realizado! Agora falta pouco.</SectionTitle>
                    <SectionSubtitle>Realize o pagamento da entrada para confirmar as novas condições.</SectionSubtitle>
                  </div>

                  <WarningBanner>
                    <WarningIconWrapper>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9 13V15H11V13H9ZM9 5V11H11V5H9Z"
                          fill="#C2600A"
                        />
                      </svg>
                    </WarningIconWrapper>
                    <WarningContent>
                      <WarningTitle>O não pagamento até o vencimento cancelará esta proposta.</WarningTitle>
                      <WarningText>
                        As condições negociadas são únicas. Em uma futura negociação, os valores serão recalculados com base nos
                        encargos do seu contrato.
                      </WarningText>
                    </WarningContent>
                  </WarningBanner>

                  <PixSection>
                    <PixLabel>Pagar entrada com PIX</PixLabel>
                    <PixQRCode>
                      {formattedData.qrCodePixImage ? (
                        <img src={formattedData.qrCodePixImage} alt="QR Code PIX" />
                      ) : (
                        <svg width="202" height="202" viewBox="0 0 202 202" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="202" height="202" fill="#F4F4F5" />
                          <rect x="25" y="25" width="50" height="50" fill="black" />
                          <rect x="127" y="25" width="50" height="50" fill="black" />
                          <rect x="25" y="127" width="50" height="50" fill="black" />
                          <rect x="127" y="127" width="50" height="50" fill="black" />
                          <rect x="88" y="88" width="26" height="26" fill="black" />
                          <rect x="76" y="51" width="26" height="26" fill="black" />
                          <rect x="101" y="127" width="26" height="26" fill="black" />
                        </svg>
                      )}
                    </PixQRCode>
                    <PixCopyButton onClick={handleCopyPix} disabled={isCopying || !formattedData.codigoPix}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_pix)">
                          <path
                            d="M5.83333 5.00008V2.50008C5.83333 2.27907 5.92113 2.06711 6.07741 1.91083C6.23369 1.75455 6.44565 1.66675 6.66667 1.66675H16.6667C16.8877 1.66675 17.0996 1.75455 17.2559 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V14.1667C17.5 14.3878 17.4122 14.5997 17.2559 14.756C17.0996 14.9123 16.8877 15.0001 16.6667 15.0001H14.1667V17.5001C14.1667 17.9601 13.7917 18.3334 13.3275 18.3334H3.33917C3.22927 18.3341 3.12033 18.313 3.0186 18.2714C2.91687 18.2299 2.82436 18.1686 2.74638 18.0912C2.6684 18.0137 2.60649 17.9216 2.56421 17.8202C2.52193 17.7188 2.50011 17.61 2.5 17.5001L2.5025 5.83342C2.5025 5.37341 2.8775 5.00008 3.34167 5.00008H5.83333ZM4.16917 6.66675L4.16667 16.6667H12.5V6.66675H4.16917ZM7.5 5.00008H14.1667V13.3334H15.8333V3.33341H7.5V5.00008Z"
                            fill="#0273FF"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_pix">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {isCopying ? 'Copiando...' : 'Copiar código PIX'}
                    </PixCopyButton>
                  </PixSection>

                  <EntryCard>
                    <EntryRow>
                      <EntryLabel>Valor da entrada</EntryLabel>
                      <EntryValue>{formattedData.valorEntrada}</EntryValue>
                    </EntryRow>
                    <EntryRow>
                      <EntrySubLabel>Venc. da entrada</EntrySubLabel>
                      <EntrySubValue>{formattedData.dataVencimentoEntrada}</EntrySubValue>
                    </EntryRow>
                  </EntryCard>

                  <AlternativePayment>
                    <AlternativeText>Você também pode pagar a entrada com boleto</AlternativeText>
                    <AlternativeActions>
                      <AlternativeLink href={formattedData.urlFaturaBoleto || '#'} target="_blank" rel="noopener noreferrer">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.0002 2.5C14.4935 2.5 18.2319 5.73333 19.016 10C18.2327 14.2667 14.4935 17.5 10.0002 17.5C5.50687 17.5 1.76854 14.2667 0.984375 10C1.76771 5.73333 5.50687 2.5 10.0002 2.5ZM10.0002 15.8333C11.6998 15.833 13.3489 15.2557 14.6776 14.196C16.0063 13.1363 16.936 11.6569 17.3144 10C16.9346 8.34442 16.0043 6.86667 14.6757 5.80835C13.3471 4.75004 11.6988 4.17377 10.0002 4.17377C8.30162 4.17377 6.65328 4.75004 5.32469 5.80835C3.99609 6.86667 3.06585 8.34442 2.68604 10C3.06446 11.6569 3.9941 13.1363 5.32283 14.196C6.65155 15.2557 8.30065 15.833 10.0002 15.8333ZM10.0002 13.75C9.00565 13.75 8.05182 13.3549 7.34856 12.6516C6.6453 11.9484 6.25021 10.9946 6.25021 10C6.25021 9.00544 6.6453 8.05161 7.34856 7.34835C8.05182 6.64509 9.00565 6.25 10.0002 6.25C10.9948 6.25 11.9486 6.64509 12.6519 7.34835C13.3551 8.05161 13.7502 9.00544 13.7502 10C13.7502 10.9946 13.3551 11.9484 12.6519 12.6516C11.9486 13.3549 10.9948 13.75 10.0002 13.75ZM10.0002 12.0833C10.5527 12.0833 11.0826 11.8638 11.4733 11.4731C11.864 11.0824 12.0835 10.5525 12.0835 10C12.0835 9.44747 11.864 8.91756 11.4733 8.52686C11.0826 8.13616 10.5527 7.91667 10.0002 7.91667C9.44767 7.91667 8.91777 8.13616 8.52707 8.52686C8.13637 8.91756 7.91687 9.44747 7.91687 10C7.91687 10.5525 8.13637 11.0824 8.52707 11.4731C8.91777 11.8638 9.44767 12.0833 10.0002 12.0833Z"
                            fill="#0273FF"
                          />
                        </svg>
                        Visualizar fatura
                      </AlternativeLink>
                      <AlternativeLink
                        href="#"
                        onClick={e => {
                          e.preventDefault()
                          handleCopyBarcode()
                        }}
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_barcode)">
                            <path
                              d="M5.83333 5.00008V2.50008C5.83333 2.27907 5.92113 2.06711 6.07741 1.91083C6.23369 1.75455 6.44565 1.66675 6.66667 1.66675H16.6667C16.8877 1.66675 17.0996 1.75455 17.2559 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V14.1667C17.5 14.3878 17.4122 14.5997 17.2559 14.756C17.0996 14.9123 16.8877 15.0001 16.6667 15.0001H14.1667V17.5001C14.1667 17.9601 13.7917 18.3334 13.3275 18.3334H3.33917C3.22927 18.3341 3.12033 18.313 3.0186 18.2714C2.91687 18.2299 2.82436 18.1686 2.74638 18.0912C2.6684 18.0137 2.60649 17.9216 2.56421 17.8202C2.52193 17.7188 2.50011 17.61 2.5 17.5001L2.5025 5.83342C2.5025 5.37341 2.8775 5.00008 3.34167 5.00008H5.83333ZM4.16917 6.66675L4.16667 16.6667H12.5V6.66675H4.16917ZM7.5 5.00008H14.1667V13.3334H15.8333V3.33341H7.5V5.00008Z"
                              fill="#0273FF"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_barcode">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        {isCopying ? 'Copiando...' : 'Copiar código de barras'}
                      </AlternativeLink>
                    </AlternativeActions>
                  </AlternativePayment>
                </ContentWrapper>
              )}
            </PaymentCard>
            <SummaryCard
              variant="awaiting"
              showDiscount={false}
              isLoading={isLoading}
              cashPayment={false}
              outstanding={{
                currentValue: formattedData.saldoDevedorAtual,
                previousValue: formattedData.saldoDevedorAnterior
              }}
              calculation={formattedData.calculation}
              paymentPlan={[
                { id: 'entry', label: 'Entrada', type: 'text', value: formattedData.valorEntrada },
                {
                  id: 'installments',
                  label: 'Parcelas',
                  type: 'text',
                  value:
                    formattedData.quantidadeParcelas && formattedData.valorParcela
                      ? `${formattedData.quantidadeParcelas}x de ${formattedData.valorParcela}`
                      : '-'
                },
                {
                  id: 'total',
                  label: 'Total pago a prazo',
                  type: 'text',
                  value: formattedData.totalPagoAPrazo,
                  highlight: true
                }
              ]}
              schedule={[
                { id: 'entry-due', label: 'Venc. da entrada', date: formattedData.dataVencimentoEntrada },
                { id: 'first-due', label: 'Venc. 1ª parcela', date: formattedData.dataVencimentoPrimeiraParcela }
              ]}
            />
          </PageGrid>
        </MaxWidth>
      </PageContainer>
    </Template>
  )
}

// Exportar o router e o componente de pagamento parcelado
export { NegotiationPayment } from './payment-router'
export { CashPayment } from './cash-payment'
